import * as React from "react";
import {createRoot, Root} from 'react-dom/client';
import {WelcomeAssistant} from "./components/WelcomeAssistant/WelcomeAssistant";
import "./style.css";
import {EmailConfirmation} from "./components/EmailConfirmation/EmailConfirmation";

(window as any).react = {

    welcome_assistant: function (target: any, config: any) {
        if (target) {
            return createRoot(target).render(
                <WelcomeAssistant config={config} />
            );
        }
    },

    email_confirmation: function (target: any, config: any) {
        if (target) {
            return createRoot(target).render(
                <EmailConfirmation config={config} />
            );
        }
    },

}
